import React from 'react'

function ViewAlum() {
  return (
    <div>ViewAlum</div>
  )
}

export default ViewAlum